import React from 'react';
import './style.css';
import ReactPlayer from 'react-player'
import Intro1 from '../../video/intro1.mp4';
import Intro2 from '../../video/intro2.mp4';


class Splash extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        video: Math.floor((Math.random() * 10) + 0),
        ended: false
    }
  }
  myHandler(){
    this.setState({ended: true})
  }
  componentDidMount(){
    const video = document.getElementsByTagName('video')[0];
    video.play()
    const el = this;
    video.onended = function(e) {
    el.myHandler()
    };
  }
  render(){
  return <div className={"splash " + (this.state.ended ? 'ended' : 'playing')}>
       { !this.state.ended && this.state.video <= 5 &&
       <video autoplay muted id="myVideo" 
       autoPlay src={Intro1}/>
       }
       { !this.state.ended && this.state.video >= 5 &&
       <video autoplay muted id="myVideo" 
       autoPlay src={Intro2} />
       }
    </div>
  };
}

export default Splash;